import { deleteHistory } from "../../api/historyService";

export const useDeleteHistory = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteHistory(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete history:", error);
            throw error;
        }
    };

    return { remove };
};